<template>
  <base-container ref="container">
    <ArtisanGrid
      ref="SysDicInfo"
      metaKey="SysDicInfo"
      :leftOption="leftOption"
      :showBefore="showBefore"
    >
      <template #leftAside>
        <artisan-group style="height:100%;overflow-y:auto;">
          <div slot="header">
            <span>字典类型</span>
          </div>
          <el-tree
            :data="data"
            default-expand-all
            node-key="id"
            ref="tree"
            highlight-current
            :expand-on-click-node="false"
            :props="defaultProps"
            @current-change="currentChange"
          >
            <div class="custom-tree-node" slot-scope="{ node, data }">
              <span v-text="node.label"></span>
              <span style="float: right">
                <template v-if="data.id">
                  <el-button
                    type="text"
                    size="mini"
                    icon="el-icon-edit"
                    @click="edit(data)"
                  ></el-button>
                  <el-button
                    type="text"
                    size="mini"
                    icon="el-icon-delete"
                    @click="del(data)"
                  ></el-button>
                </template>
                <el-button
                  v-else
                  type="text"
                  size="mini"
                  icon="el-icon-plus"
                  @click="add(data)"
                ></el-button
              ></span>
            </div>
          </el-tree>
        </artisan-group>
      </template>
    </ArtisanGrid>
    <artisan-dialog
      ref="dialog"
      :title="title"
      width="60%"
      :visible.sync="isShow"
      v-loading="isLoading"
    >
      <el-form
        ref="dicTypeForm"
        label-width="100px"
        :rules="rules"
        size="mini"
        :model="formData"
      >
        <el-row style="margin-top: 20px">
          <el-col :span="12" :offset="6">
            <el-form-item label="是否有效">
              <el-radio-group v-model="formData.isValid">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="6">
            <el-form-item label="编码" prop="code">
              <el-input v-model="formData.code"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="6">
            <el-form-item label="名称" prop="name">
              <el-input v-model="formData.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="6">
            <el-form-item label="备注">
              <el-input type="textarea" v-model="formData.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <el-button type="primary" size="mini" @click="save">保存</el-button>
      </template>
    </artisan-dialog>
  </base-container>
</template>

<script>
import { list, add, edit, remove } from "@/api/sys/dicType";
export default {
  data() {
    return {
      isShow: false,
      isEdit: false,
      isLoading: false,
      formData: {
        isValid: true,
        code: "",
        name: "",
        remark: "",
      },
      rules: {
        code: [
          { required: true, message: "请输入编码", trigger: "blur" },
          {
            min: 3,
            max: 32,
            message: "长度在 3 到 32 个字符",
            trigger: "blur",
          },
        ],
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          {
            min: 2,
            max: 16,
            message: "长度在 2 到 16 个字符",
            trigger: "blur",
          },
        ],
      },
      data: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      leftOption: {
        width:"20%"
      },
    };
  },
  computed: {
    title() {
      return this.isEdit ? "编辑--字典类型" : "新增--字典类型";
    },
  },
  created() {
    this.loadDicTypes();
  },
  methods: {
    showBefore(row, type) {
      if (type == "add") {
        let node = this.$refs.tree.getCurrentNode();
        if (node) row.dicTypeId = node.id + "";
      }
    },
    currentChange(data) {
      this.$refs.SysDicInfo.reload({
        dicTypeId: data.id,
      });
    },
    loadDicTypes() {
      list({
        orderBy: "createTime",
        isDesc: false,
        filterParams: [
          {
            name: "isValid",
            value: true,
          },
        ],
      }).then((res) => {
        let data = res.data.data;
        let root = { id: "", name: "所有", children: data };
        this.data = [root];
      });
    },
    add() {
      this.isShow = true;
      this.isEdit = false;
      this.formData = {
        isValid: true,
        code: "",
        name: "",
        remark: "",
      };
    },
    edit(data) {
      this.isShow = true;
      this.isEdit = true;
      this.formData = data;
    },
    del(data) {
      this.$refs.container.confirm({
        msg: "确认删除？",
        confirm: () => {
          remove(data.id).then(() => {
            this.loadDicTypes();
            this.$refs.SysDicInfo.reloadDicByCol("dicTypeId");
            this.$message({
              type: "success",
              message: "删除成功！",
            });
          });
        },
      });
    },
    save() {
      this.$refs.container.confirm({
        msg: "确认保存？"})
        .then(() => {
          if (this.isEdit) {
            edit(this.formData).then(() => {
              this.isShow = false;
              this.loadDicTypes();
              this.$refs.SysDicInfo.reloadDicByCol("dicTypeId");
              this.$message({
                type: "success",
                message: "编辑成功！",
              });
            });
          } else {
            add(this.formData).then(() => {
              this.isShow = false;
              this.loadDicTypes();
              this.$refs.SysDicInfo.reloadDicByCol("dicTypeId");
              this.$message({
                type: "success",
                message: "保存成功！",
              });
            });
          }
        });
    },
  },
};
</script>

<style>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>